module.exports = __webpack_public_path__ + "static/20190327_iPhone-X-Mockup_2019_dashboard_shadow-fde78c0fdf4fad267ec4decdc551442b.jpg";